import axios from 'axios'

/**
 * Настройка axios интерсепторов для логирования запросов и ответов
 */
export function setupAxiosInterceptors() {
  // Инициализация токена при старте
  const token = localStorage.getItem('auth_token')
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    console.log('🔑 Токен загружен из localStorage')
  }

  // Интерсептор запросов
  axios.interceptors.request.use(
    (config) => {
      console.log('🚀 AXIOS REQUEST:', {
        url: config.url,
        method: config.method,
        headers: config.headers
      })
      return config
    },
    (error) => {
      console.error('❌ AXIOS REQUEST ERROR:', error)
      return Promise.reject(error)
    }
  )

  // Интерсептор ответов
  axios.interceptors.response.use(
    (response) => {
      console.log('✅ AXIOS RESPONSE SUCCESS:', {
        url: response.config.url,
        status: response.status,
        statusText: response.statusText,
        data: response.data
      })
      return response
    },
    (error) => {
      console.error('❌ AXIOS RESPONSE ERROR:', {
        message: error.message,
        code: error.code,
        url: error.config?.url,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      })

      // Если 401 - токен невалиден, выходим
      if (error.response?.status === 401) {
        console.warn('🚪 Получен 401, выход из системы')
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
        delete axios.defaults.headers.common['Authorization']

        // Перенаправляем на логин, если не на странице логина
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login'
        }
      }

      return Promise.reject(error)
    }
  )

  console.log('✅ Axios интерсепторы настроены')
}

export default axios
